import { useQuery } from "react-query";
import { getVacancies } from "../services/school/vacancy/vacancy";
import { PagedRequestType } from "../types/PagedResults";
import { Key_vacancies } from "../utils/constants";

export const useGetVacanciesQuery = (data: PagedRequestType, options:any = null) =>
  useQuery(
    [Key_vacancies, JSON.stringify(data)],
    () => getVacancies(data), 
    options?{...options}:{}
  );